<template>
  <div>
    <!-- Banner -->
    <v-banner color="secondary" outlined>
      <h2>تور مجازی</h2>
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-left</v-icon>
        </template>
      </v-breadcrumbs>
    </v-banner>
    <!-- Panoramas -->
    <v-row class="pa-6">
      <v-col v-for="(panorama, i) in panoramas" :key="i" cols="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card
            hover
            :href="panorama.url"
            class="rounded-lg"
            :elevation="hover ? 3 : 0"
            :class="{ 'on-hover': hover }"
          >
            <v-img
              :src="panorama.image"
              max-height="300"
              :aspect-ratio="16 / 9"
              contain
              class="grey lighten-2 rounded-lg"
            >
              <v-fade-transition>
                <v-overlay v-if="hover" absolute color="#000000">
                  <p class="text-h6 mt-4 subheading text-center">
                    {{ panorama.description }}
                  </p>
                </v-overlay>
              </v-fade-transition>
              <!-- <template v-slot:placeholder>
                <v-row class="fill-height ma-0 justify-center align-center">
                  <v-progress-circular
                    indeterminate
                    color="blue darken-4"
                  ></v-progress-circular>
                </v-row>
              </template> -->
            </v-img>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LoadingOverlay from "@/layouts/LoadingOverlay-temp-2.vue";
export default {
  data() {
    return {
      items: [
        {
          text: "خانه",
          disabled: false,
          href: "/",
        },
        {
          text: "تور مجازی",
          disabled: false,
          href: "virtual-tour",
        },
      ],
      panoramas: [],
      type: "scale",
    };
  },
  components: {
    LoadingOverlay,
  },
  created() {
    this.getPanorama();
  },
  metaInfo() {
    return {
      title: "نامیا",
      titleTemplate: "%s | تور مجازی",
    };
  },
  head: {
    link: [
      {
        rel: "canonical",
        href: "https://namya.ir/",
        id: "canonical",
      },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        name: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "",
      },
      {
        name: "twitter:title",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        name: "twitter:description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "" },
      {
        name: "twitter:image:src",
        content:
          "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        itemprop: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        itemprop: "image",
        content:
          "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },
    ],
  },
  methods: {
    async getPanorama() {
      let response = await this.axios
        .get("https://namya.ir/api/v1/businesses/getPanoramas/48")
        .then((response) => {
          this.panoramas = response.data.data;
        });
    },
  },
};
</script>

<style scoped>
* >>> .v-image__image--contain {
  background-size: cover;
}

.v-card {
  transition: opacity 0.2s ease-in-out;
}

.v-card:hover {
  opacity: 0.8;
}

.v-card:not(.on-hover) {
  opacity: 1;
}

.v-responsive {
  align-items: center;
}

.v-card__title {
  color: #dee2e6;
  justify-content: center;
}

.v_card:hover .v_card__title {
  opacity: 1;
}

.v-application .text-h6 {
  font-family: IRANSansX, sans-serif !important;
  font-size: 12px !important;
  font-weight: 800;
}
</style>
